import { lazy, Suspense } from 'react';
import { BrowserRouter, Routes, Route, Navigate } from 'react-router-dom';
import ProtectedRoute from './ProtectedRoute';
import ForcedPasswordGate from './ForcedPasswordGate';

const LoginPage           = lazy(() => import('../pages/LoginPage'));
const RegisterPage        = lazy(() => import('../pages/RegisterPage'));
const DashBoardRoute      = lazy(() => import('../pages/dashboard/DashBoardRoute'));
const ContestDetailPage   = lazy(() => import('../pages/ContestDetail/ContestDetailPage'));
const PendingRequestsPage = lazy(() => import('../pages/PendingRequests/PendingRequestsPage'));
const SettingsRoute       = lazy(() => import('../pages/settings/SettingsRoute'));
const FallBackPage        = lazy(() => import('../pages/FallBackPage'));
const ChangePasswordPage  = lazy(() => import('../pages/ChangePasswordPage'));
const TestSetDetailPage   = lazy(() => import('../pages/TestSetDetail/TestSetDetailPage'));
const HomeRoute           = lazy(() => import('../pages/Home/HomeRoute'));
const MyContestsPage      = lazy(() => import('../pages/MyContests/MyContestsPage'));

/**
 * Definizione centralizzata di tutte le route dell'applicazione.
 * La navigazione principale avviene tramite la Home (logica a tab)
 * e la sidebar (My Contests, Dashboard, Settings).
 */
export default function AppRouter() {
  return (
    <BrowserRouter>
      <Suspense fallback={<div>Loading...</div>}>
        <Routes>
          {/* Pubbliche */}
          <Route path="/login"    element={<LoginPage />} />
          <Route path="/register" element={<RegisterPage />} />

          {/* Home — pubblica (guest + autenticati) */}
          <Route path="/home" element={<ForcedPasswordGate><HomeRoute /></ForcedPasswordGate>} />

          {/* Contest detail — pubblica (raggiungibile dai tab della home) */}
          <Route path="/contests/:id" element={<ForcedPasswordGate><ContestDetailPage /></ForcedPasswordGate>} />

          {/* Test set detail — pubblica (download inibito per guest e test set privati) */}
          <Route path="/test-sets/:id" element={<ForcedPasswordGate><TestSetDetailPage /></ForcedPasswordGate>} />

          {/* My Contests — solo utenti autenticati con ruolo user */}
          <Route path="/my-contests" element={
            <ProtectedRoute allowedRoles={['user']}>
              <MyContestsPage />
            </ProtectedRoute>
          } />

          <Route path="/dashboard" element={
            <ProtectedRoute><DashBoardRoute /></ProtectedRoute>
          } />

          {/* Forced password change */}
          <Route path="/change-password" element={
            <ProtectedRoute>
              <ChangePasswordPage />
            </ProtectedRoute>
          } />

          {/* Solo admin */}
          <Route path="/pending-requests" element={
            <ProtectedRoute allowedRoles={['contest_admin', 'super_admin']}>
              <PendingRequestsPage />
            </ProtectedRoute>
          } />

          {/* Settings */}
          <Route path="/settings" element={
            <ProtectedRoute allowedRoles={['super_admin', 'contest_admin', 'user']}>
              <SettingsRoute />
            </ProtectedRoute>
          } />

          {/* Root → Home */}
          <Route path="/" element={<Navigate to="/home" replace />} />

          <Route path="*" element={<FallBackPage />} />
        </Routes>
      </Suspense>
    </BrowserRouter>
  );
}
